//measured in seconds
export const ALLOWABLE_INACTIVITY = 300;
